import DownloadAttachmentReducer from './downloadAttachment';
import ParseAttachmentReducer from './parseAttachment';

const attachmentRootReducer = {
  downloadAttachmentStorage: DownloadAttachmentReducer,
  parseAttachmentStorage: ParseAttachmentReducer,
};

export { attachmentRootReducer };
